import { Slide } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekSlide = styled(Slide)(() => ({}));

export { PeekSlide, PeekSlide as default };
